import type { ReactElement } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { LandingNav } from '../components/LandingNav'
import { LandingFooter } from '../components/LandingFooter'
import { SEOSteps } from '../components/seo/SEOSteps'
import { SEOFreeBanner } from '../components/seo/SEOFreeBanner'
import { SEOWaitlist } from '../components/seo/SEOWaitlist'
import { SEOFAQ } from '../components/seo/SEOFAQ'
import './SEOTemplateBPage.css'

interface Feature { icon: ReactElement; title: string; desc: string }
interface FAQItem { q: string; a: string }

interface Props {
  meta: { title: string; description: string }
  eyebrow: string
  h1: string
  h1accent: string
  sub: string
  features: Feature[]
  contentBlocks: { heading: string; text: string }[]
  faq: FAQItem[]
}

export function SEOTemplateBPage({ meta, eyebrow, h1, h1accent, sub, features, contentBlocks, faq }: Props) {
  const navigate = useNavigate()
  const goHome = () => navigate('/')

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
      </Helmet>

      <LandingNav onStart={goHome} />

      <section className="seo-b-hero">
        <div className="seo-b-hero-inner">
          <div className="seo-b-eyebrow">{eyebrow}</div>
          <h1 className="seo-b-h1">{h1} <span className="seo-b-accent">{h1accent}</span></h1>
          <p className="seo-b-sub">{sub}</p>
          <button className="seo-b-cta" onClick={goHome}>✓ Kostenlos testen — sofort starten</button>
          <div className="seo-b-trust">
            <span>PDF kostenlos (mit Wasserzeichen)</span>
            <span className="seo-trust-sep">·</span>
            <span>Vollständig für einmalig €4,99</span>
            <span className="seo-trust-sep">·</span>
            <span>Kein Abo</span>
            <span className="seo-trust-sep">·</span>
            <span>Kein Account</span>
          </div>
        </div>
      </section>

      <section className="seo-b-features">
        <div className="seo-b-features-inner">
          {features.map((f, i) => (
            <div key={i} className="seo-b-feat">
              <div className="seo-b-feat-icon">{f.icon}</div>
              <strong>{f.title}</strong>
              <span>{f.desc}</span>
            </div>
          ))}
        </div>
      </section>

      <SEOSteps onStart={goHome} />

      <section className="seo-b-content">
        <div className="seo-b-content-inner">
          {contentBlocks.map((b, i) => (
            <div key={i}>
              <h2>{b.heading}</h2>
              <p>{b.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="seo-b-cta-section">
        <div className="seo-b-cta-inner">
          <SEOFreeBanner onStart={goHome} />
          <div className="seo-b-divider">oder</div>
          <SEOWaitlist />
        </div>
      </section>

      <SEOFAQ items={faq} />
      <LandingFooter />
    </>
  )
}
